import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column justify-content-center align-items-center h-100" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header d-flex justify-content-center align-items-center p-2" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "404"),
  /*#__PURE__*/_createElementVNode("h3", { class: "text-secondary ms-3" }, "Страница не найдена")
], -1)
const _hoisted_4 = { class: "card-body p-3" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Нажмите ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("сюда")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" чтобы вернуться на главную")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Или ждите ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" секунд и вы перенесётесь туда автоматически")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", null, [
          _hoisted_5,
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _hoisted_7
        ]),
        _createElementVNode("p", null, [
          _hoisted_8,
          _createElementVNode("strong", null, _toDisplayString(_ctx.remainingTime), 1),
          _hoisted_9
        ])
      ])
    ])
  ]))
}